import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

export const importModule: ForqModuleManifest = {
  id: 'import',
  name: 'Datenübernahme',
  description: 'Kunden- und Maschinenstamm aus C.O.S. Arista per CSV übernehmen',
  version: '0.1.0',
  route: '/datenimport',
  category: 'system',
  status: 'development',
  requiredPermissions: ['admin.tenants.manage'],
  features: ['import.customers', 'import.machines'],
  navigation: [
    // 'primary' ist die Platzierung, die die Seitenleiste WIRKLICH rendert (AppShell filtert
    // darauf). Ein Eintrag nur mit 'launcher' erscheint nirgends -- dann ist das Modul allein
    // über die URL erreichbar, und niemand findet es.
    {
      id: 'import.home', label: 'Datenübernahme', route: '/datenimport',
      placement: 'primary', order: 910, icon: 'datenuebernahme',
    },
    {
      id: 'import.launcher', label: 'Datenübernahme', route: '/datenimport',
      placement: 'launcher', order: 910, icon: 'datenuebernahme',
    },
  ],
};

export const importFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'import.customers', moduleId: 'import', name: 'Kunden übernehmen',
    description: 'Kundenstamm aus einer Arista-CSV prüfen und übernehmen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.tenants.manage'], uiSlots: ['dashboard.main'], emits: ['import.customers.done'], listensTo: ['tenant.changed'],
  },
  {
    id: 'import.machines', moduleId: 'import', name: 'Maschinen übernehmen',
    description: 'Maschinenstamm aus einer Arista-CSV prüfen und übernehmen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.tenants.manage'], uiSlots: ['dashboard.main'], emits: ['import.machines.done'], listensTo: ['tenant.changed'],
  },
];
